// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import React, {useContext, useRef} from 'react';
import cn from 'classnames';
import Icon_close from '../../../oculus/pub/img/icons/16/close_grey.svg';
import Icon_warning from '../../../oculus/pub/img/icons/16/warning.svg';
import styles from './rotate_approval_dialog.module.less';
import {use_click_outside} from '../../../hola/pub/lib/use_click_outside';
import {Button} from '../button';
import {Settings_context} from '../../../hola/pub/settings_ctx';

interface i_rotate_approval_dialog_props {
    is_open: boolean;
    on_close: ()=>void;
    on_confirm: ()=>void;
    loading?: boolean;
    cls?: string;
    style?: React.CSSProperties;
    title?: string;
    sub_title?: React.ReactNode;
    confirm_caption?: React.ReactNode;
    cancel_caption?: React.ReactNode;
}

export const Rotate_approval_dialog =
    (props: i_rotate_approval_dialog_props)=>{
    const {
        is_open, on_close, on_confirm, loading, cls, style,
        title, sub_title, confirm_caption, cancel_caption,
    } = props;
    const {theme} = useContext(Settings_context);
    const ref = useRef<HTMLDivElement>(null);
    use_click_outside(ref, on_close);
    if (!is_open)
      return null;
    return <div
      ref={ref}
      className={cn(styles.approval_popup, cls)}
      style={style}
      onClick={ev=>ev.stopPropagation()}
      tabIndex={-1}>
      <div className={styles.header_row}>
        <div className={styles.hero}>
          <div className={styles.warning_circle}>
            <Icon_warning className={styles.warning_icon}/>
          </div>
        </div>
        <div className={styles.texts}>
          <p className={cn(styles.title, theme.p16, theme.bold,
            theme.color_n700)}>
            {title ?? 'Proxy rotation approval'}
          </p>
          <p className={cn(styles.sub_title, theme.p14, theme.reg)}>
            {sub_title ?? 'Rotating your proxies will permanently change your'+
              ' current proxy list. This action cannot be undone. Are you'+
              ' sure you want to proceed?'}
          </p>
        </div>
        <button className={styles.close_btn} aria-label='Close'
          onClick={on_close}>
          <Icon_close/>
        </button>
      </div>
      <div className={styles.footer_row}>
        <Button
          caption={cancel_caption ?? 'Close'}
          color="secondary"
          on_click={on_close}
          cls={styles.btn_xs}
        />
        <Button
          caption={loading ? 'Processing…' :
            confirm_caption ?? 'Rotate proxies'}
          color="primary"
          on_click={on_confirm}
          cls={styles.btn_xs}
        />
      </div>
    </div>;
};
